import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from 'src/app/configs/app-config.constants';
import { InterfaceAppConfig } from 'src/app/configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class PreviousDataService {
    private apiUrl: string;
    private apiGyanUrl: string;
    private scrollSubject = new Subject<string>();
    scrollEvent$ = this.scrollSubject.asObservable();

    private callAllTopicDetailsSubject = new Subject<void>();
    callAllTopicDetailsEvent$ = this.callAllTopicDetailsSubject.asObservable();

    private callFindByNameSubject = new Subject<string>();
    callFindByNameEvent$ = this.callFindByNameSubject.asObservable();

    private topicClickSubject = new Subject<{ topicName: string; topicId: number; topicStatus: string }>();
    topicClickEvent$ = this.topicClickSubject.asObservable();

    private fetchFolderList = new BehaviorSubject<Array<string>>([]);
    currentFolders = this.fetchFolderList.asObservable();

    private callTopicDetailsSubject = new Subject<number>();
    callTopicDetailsEvent$ = this.callTopicDetailsSubject.asObservable();

    private callTopicUpdateSubject = new Subject<any>();
    callTopicUpdateEvent$ = this.callTopicUpdateSubject.asObservable();

    private callAllTopicWithParamSubject = new Subject<number>();
    callAllTopicWithParamEvent$ = this.callAllTopicWithParamSubject.asObservable();

    private callAllTopicDataSubject = new Subject<any>();
    callAllTopicDataEvent$ = this.callAllTopicDataSubject.asObservable();

    private callLoadingSubject = new Subject<any>();
    callLoadingEvent$ = this.callLoadingSubject.asObservable();

    private callMoveSubject = new Subject<any>();
    callMoveEvent$ = this.callMoveSubject.asObservable();

    private callDeleteSubject = new Subject<any>();
    callDeleteEvent$ = this.callDeleteSubject.asObservable();

    private callMoveTopicSubject = new Subject<any>();
    callMoveTopicEvent$ = this.callMoveTopicSubject.asObservable();

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {
        this.apiUrl = environment.apiurl;
        this.apiGyanUrl = environment.gyanApiUrl;
    }

    getPreviousGyanData(data: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        return this.http.post(this.apiUrl + this.config.apis.previousSearch.getPreviousList, data);
    }

    deleteGyan(gyanId: number, personId: number): Observable<any> {
        // debugger;
        console.log(' >>>>>>>>>>> deleteGyan 69');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        return this.http.delete(`${this.apiUrl}${this.config.apis.previousSearch.deleteGyan}${personId}&gyanId=${gyanId}`);
        //{ headers: headers });
        // const mockedResponse = { message: 'Deleted gyan successfully', error: null, statusCode: 200, data: null };

        // return of(mockedResponse);
    }

    deleteTopic(topicId: number, personId: number): Observable<any> {
        //debugger;
        console.log(' >>>>>>>>>>> deleteGyan 83');

        const headers = new HttpHeaders({
            'Content-Type': 'application/json1',
        });

        return this.http.delete(`${this.apiGyanUrl}${this.config.apis.advaceQuerySearch.deleteGyan}${topicId}`);
        //{ headers: headers });
        // const mockedResponse = { message: 'Deleted gyan successfully', error: null, statusCode: 200, data: null };

        // return of(mockedResponse);
    }

    pushTopic(data: any): Observable<any> {
        return this.http.post(this.apiGyanUrl + this.config.apis.advaceQuerySearch.pushgyan, data);
    }

    renameGyan(data: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        return this.http.put(this.apiUrl + this.config.apis.previousSearch.renameGyan, data);
    }

    getAdvanceQueryData(data: any): Observable<any> {
        // debugger;
        return this.http.post(this.apiGyanUrl + this.config.apis.advaceQuerySearch.getAdvanceQueryList, data);
    }

    notifytoupprewarmingaci(): Observable<any> {
        return this.http.get(this.apiGyanUrl + this.config.apis.advaceQuerySearch.notifytoupprewarmingaci);
    }

    deleteAqGyan(topicId: number, personId: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        return this.http.delete(`${this.apiUrl}${this.config.apis.advaceQuerySearch.deleteTopic}${personId}&gyanId=${topicId}`);
        //{ headers: headers });
        // const mockedResponse = { message: 'Deleted gyan successfully', error: null, statusCode: 200, data: null };

        // return of(mockedResponse);
    }

    renameAqGyan(data: any): Observable<any> {
        return this.http.put(this.apiUrl + this.config.apis.advaceQuerySearch.renameAQ, data);
    }

    getFindByName(data: any): Observable<any> {
        return this.http.post(this.apiGyanUrl + this.config.apis.gyan.organisation.searchtopicbyname, data);
    }

    fetchFoldersList(folderId: any): Observable<any> {
        let url = this.apiGyanUrl + this.config.apis.gyan.organisation.fetchFoldersList;
        if (folderId) {
            url = this.apiGyanUrl + this.config.apis.gyan.organisation.fetchFoldersList + '?folderId=' + folderId;
        }
        return this.http.get(url);
    }

    moveGyan(reqBody: any): Observable<any> {
        const url = this.apiGyanUrl + this.config.apis.gyan.organisation.movemultiplegyan;
        return this.http.post(url, reqBody);
    }

    updateTopicName(reqBody: any): Observable<any> {
        const url = this.apiGyanUrl + this.config.apis.gyan.organisation.editTopicName;
        return this.http.put(url, reqBody);
    }

    updateFolderName(folderId: number, reqBody: any): Observable<any> {
        const url = this.apiGyanUrl + this.config.apis.gyan.organisation.editFolderName + '?folderId=' + folderId;
        return this.http.put(url, reqBody);
    }

    deleteFolder(id: number): Observable<any> {
        const url = this.apiGyanUrl + this.config.apis.gyan.organisation.deleteFolder + '?folderId=' + id;
        return this.http.delete(url);
    }

    updateFolderList(folders: Array<string>) {
        this.fetchFolderList.next(folders);
    }

    emitScrollEvent(data: string) {
        this.scrollSubject.next(data);
    }

    emitTopicClickEvent(data: { topicName: string; topicId: number; topicStatus: string }): void {
        this.topicClickSubject.next(data);
    }

    emitCallAllTopicDetailsClickEvent() {
        console.log('emitCallAllTopicDetailsClickEvent');
        this.callAllTopicDetailsSubject.next();
    }

    emitCallTopicDetailsClickEvent(topicId: number) {
        this.callTopicDetailsSubject.next(topicId);
    }

    emitCallTopicUpdateClickEvent(topicId: number, topicName: string, type: string, parentFolderId: any) {
        //this.callTopicUpdateSubject.next(topicId, topicName, type);
        this.callTopicUpdateSubject.next({ topicId: topicId, topicName: topicName, type: type, parentFolderId: parentFolderId });
    }

    emitCallFindByNameClickEvent(data: string) {
        console.log('emitCallFindByNameClickEvent.data', data);
        this.callFindByNameSubject.next(data);
    }

    emitCallAllTopicWithParamClickEvent(data: any) {
        console.log('emitCallAllTopicWithParamClickEvent.data', data);
        this.callAllTopicWithParamSubject.next(data);
    }

    emitCallAllTopicDataClickEvent(data: any) {
        console.log('emitCallAllTopicDataClickEvent');
        this.callAllTopicDataSubject.next(data);
    }

    emitLoadingClickEvent(data: any) {
        console.log('emitLoadingClickEvent');
        this.callLoadingSubject.next(data);
    }

    emitMoveClickEvent(data: any) {
        console.log('emitMoveClickEvent');
        this.callMoveSubject.next(data);
    }

    emitDeleteClickEvent(data: any) {
        console.log('emitDeleteClickEvent');
        this.callDeleteSubject.next(data);
    }

    emitMoveTopicClickEvent(data: any) {
        console.log('emitMoveTopicClickEvent');
        this.callMoveTopicSubject.next(data);
    }
}
